<template>
  <!-- 头像/名字审核-头像审核 -->
  <div class="examine_avatar">
    <!-- header头部 -->
    <header>
      <el-form :inline="true" :model="query" class="demo-form-inline">
        <el-form-item>
          <el-input v-model="query.avatar_id" placeholder="用户ID"></el-input>
        </el-form-item>
        <el-form-item>
          <el-input v-model="query.name" placeholder="用户名称"></el-input>
        </el-form-item>
        <el-form-item>
          <el-select
            v-model="query.avatar_type"
            style="margin-right: 20px"
            @change="getData(1)"
            placeholder="请选择类型"
          >
            <el-option :value="undefined">全部</el-option>
            <el-option value="user" label="用户"></el-option>
            <el-option value="team" label="战团"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="getData(1)">查询</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="openChangeStateDialog"
            >批量修改状态</el-button
          >
        </el-form-item>
      </el-form>
    </header>

    <!-- body内容 -->
    <div class="body-box" v-loading="loading">
      <el-table :data="userList" @selection-change="handleSelectionChange">
        <el-table-column type="selection" align="center"> </el-table-column>
        <el-table-column label="ID" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.avatar && row.avatar.id }}</span>
          </template>
        </el-table-column>
        <el-table-column label="类型" align="center">
          <template slot-scope="{ row }">
            <el-tag v-if="row.avatar_type == 'user'">用户</el-tag>
            <el-tag type="warning" v-if="row.avatar_type == 'team'"
              >战团</el-tag
            >
          </template>
        </el-table-column>
        <el-table-column label="名称" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.avatar && row.avatar.name }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="id" label="审核头像" align="center">
          <template slot-scope="{ row }">
            <!-- <el-image
              style="width: 100px"
              :src="row.avatar_img"
              fit="cover"
            ></el-image> -->
            <el-image
              style="width: 100px"
              fit="cover"
              :src="row.avatar_img"
              :preview-src-list="srcList"
            ></el-image>
          </template>
        </el-table-column>
        <el-table-column prop="created_at" label="提交时间" align="center">
        </el-table-column>
        <el-table-column
          prop="action"
          label="操作"
          align="center"
          fixed="right"
        >
          <template slot-scope="{ row }">
            <el-button type="primary" size="small" @click="passEvent(row)"
              >通过</el-button
            >
            <el-button type="danger" size="small" @click="rejectEvent(row)"
              >拒绝</el-button
            >
          </template>
        </el-table-column>
      </el-table>

      <!-- 底部分页条 -->
      <el-pagination
        background
        :page-size="dataMeta.per_page || 15"
        :total="dataMeta.total || 0"
        :current-page="dataMeta.current_page"
        @current-change="handlePageChange"
        v-if="dataMeta && dataMeta.total > dataMeta.per_page"
      ></el-pagination>
    </div>

    <!-- 弹窗 -->
    <!-- 批量修改订单状态 -->
    <el-dialog
      :visible.sync="changeStateVisible"
      title="修改选中订单状态"
      width="350px"
      :close-on-click-modal="false"
    >
      <el-form
        v-if="fromData"
        :model="fromData"
        ref="fromData"
        label-width="100px"
        size="small"
        :rules="rules"
      >
        <el-form-item prop="status" label="订单状态">
          <el-select v-model="fromData.status" placeholder="请选择状态">
            <el-option label="通过" :value="1"></el-option>
            <el-option label="拒绝" :value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button size="small" @click="changeStateVisible = false"
            >取 消</el-button
          >
          <el-button
            size="small"
            type="primary"
            @click="changeState"
            :loading="buttonLoading"
            >确 定</el-button
          >
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
import { mapActions, mapMutations, mapState } from 'vuex'
import http, { getData, postData, patchData, server, postApiData, patchApiData, getApiData } from '../../http'

export default {
  components: {
  },
  props: {
  },
  data() {
    return {
      changeStateVisible: false,//批量修改弹窗显示标志
      loading: false,//加载动画
      buttonLoading: false,//按钮加载动画
      srcList: [],//大图预览图片列表
      query: {//查询条件
        page: 1,
        avatar_id: undefined,
        name: undefined,
        avatar_type: undefined
      },
      userList: undefined,//数据列表
      multipleSelection: [],//多选框选择的数据列表
      fromData: {
        status: 1,//提交的状态,默认通过1
      },
      dataMeta: undefined,//底部跳转页面条
      rules: { //验证规则
        status: [{
          required: true,
          message: '请选择状态',
          trigger: 'blur'
        }],
      }
    }
  },
  computed: {
  },
  watch: {
  },
  created() {
    this.getData(1)//拿取列表信息
  },
  mounted() { },
  methods: {
    getData(num) {
      //拿取列表数据
      if (num == 1) {
        this.query.page = 1
      }
      this.loading = true
      let params = this.query
      getApiData('avatars', params).then(res => {
        if (res) {
          this.userList = res.data
          this.getPreviewImgs(res.data)//加入预览图片
          //设置底部导航条数据
          this.dataMeta = res
        }
      }).finally(() => {
        this.loading = false
      })
    },
    getPreviewImgs(data) {
      //将获取到的列表的图片地址加入大图预览数组中
      if (data && data.length) {
        let arr = []
        for (let i = 0; i < data.length; i++) {
          arr.push(data[i].avatar_img)
        }
        this.srcList = arr
      }
    },
    handleSelectionChange(val) {
      //多选框选择事件,存储多选的数据数组
      this.multipleSelection = val
    },
    openChangeStateDialog() {
      //打开批量修改状态弹窗
      if (this.multipleSelection.length <= 0) {
        this.$message.warning("请先勾选用户")
      } else {
        this.changeStateVisible = true
      }
    },
    changeState() {
      //保存批量修改状态
      this.$refs['fromData'].validate((valid) => {
        if (valid) {
          this.buttonLoading = true
          //拿取选择的数据的ID，生成一个新的数组
          const ids = this.multipleSelection.map((item) => {
            return item.id
          })
          let params = {
            ids: ids,
            status: this.fromData.status
          }
          patchApiData('avatars', params).then(res => {
            if (res) {
              this.$message.success(res.message)
              this.changeStateVisible = false//关闭弹窗
              this.getData(1)//刷新数据
            }
          }).finally(() => {
            this.buttonLoading = false
          })
        }
      })
    },
    passEvent(rowInfo) {
      //通过修改
      let params = {
        ids: [rowInfo.id],
        status: 1
      }
      patchApiData('avatars', params).then(res => {
        if (res) {
          this.$message.success(res.message)
          this.getData()//刷新数据
        }
      })
    },
    rejectEvent(rowInfo) {
      //拒绝修改
      let params = {
        ids: [rowInfo.id],
        status: 2
      }
      patchApiData('avatars', params).then(res => {
        if (res) {
          this.$message.success(res.message)
          this.getData()//刷新数据
        }
      })
    },
    handlePageChange(page) {
      //页面底部跳转页面
      this.query.page = page
      this.getData();
    },

  }
}
</script>
<style lang="less" scoped>
header {
}
.body-box {
  .el-table /deep/ .prize-info {
    display: flex;
  }

  .el-table /deep/ .el-button {
    margin-bottom: 10px;
  }
}
</style>